import React from "react";
import classes from "./OurServices.module.css";

const RenderColService = React.memo(
  ({ image, title, hook, deliverables, bestFor, reverse }) => (
    <article
      className={`${classes.service} ${reverse ? classes.reverse : ""}`}
    >
      <div className={classes.media}>
        <img src={image} alt="" />
      </div>
      <div className={classes.body}>
        <h3 className={classes.serviceTitle}>{title}</h3>
        <p className={classes.hook}>{hook}</p>
        <p className={classes.label}>What you get</p>
        <ul className={classes.deliverables}>
          {deliverables.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p className={classes.bestFor}>
          <span>Best for</span> {bestFor}
        </p>
      </div>
    </article>
  )
);

export default RenderColService;
